module.exports = __webpack_public_path__ + "static/media/walletIcon.f8844c98.png";